export const CLEAR_COMBO_TASKS_PAGE = '@@toyota/CLEAR_COMBO_TASKS_PAGE';
export const SELECT_COMBO = '@@toyota/SELECT_COMBO';
export const SELECT_COMBO_TASK = '@@toyota/SELECT_COMBO_TASK';
export const ADD_COMBO_TASK = '@@toyota/ADD_COMBO_TASK';
export const REMOVE_COMBO_TASK = '@@toyota/REMOVE_COMBO_TASK';
export const GETTING_ACCESSORIES_COMBOS = '@@toyota/GETTING_ACCESSORIES_COMBOS';
export const GOTTEN_ACCESSORIES_COMBOS = '@@toyota/GOTTEN_ACCESSORIES_COMBOS';
export const GOTTEN_ACCESSORIES_COMBOS_FAILED = '@@toyota/GOTTEN_ACCESSORIES_COMBOS_FAILED';
export const GETTING_COMBO_TASKS = '@@toyota/GETTING_COMBO_TASKS';
export const GOTTEN_COMBO_TASKS = '@@toyota/GOTTEN_COMBO_TASKS';
export const GOTTEN_COMBO_TASKS_FAILED = '@@toyota/GOTTEN_COMBO_TASKS_FAILED';
export const GETTING_COMBO_CANDIDATE_TASKS = '@@toyota/GETTING_COMBO_CANDIDATE_TASKS';
export const GOTTEN_COMBO_CANDIDATE_TASKS = '@@toyota/GOTTEN_COMBO_CANDIDATE_TASKS';
export const GOTTEN_COMBO_CANDIDATE_TASKS_FAILED = '@@toyota/GOTTEN_COMBO_CANDIDATE_TASKS_FAILED';
export const DELETING_COMBO_TASK = '@@toyota/DELETE_COMBO_TASK';
export const DELETED_COMBO_TASK = '@@toyota/DELETED_COMBO_TASK';
export const DELETED_COMBO_TASK_FAILED = '@@toyota/DELETED_COMBO_TASK_FAILED';
export const ASSIGNING_COMBO_TASK = '@@toyota/ASSIGNING_COMBO_TASK';
export const ASSIGNED_COMBO_TASK = '@@toyota/ASSIGNED_COMBO_TASK';
export const ASSIGNED_COMBO_TASK_FAILED = '@@toyota/ASSIGNED_COMBO_TASK_FAILED';
